// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"31180850","455":"1c5f4d0d"}[chunkId] + ".chunk.js";
};